<template>
    <div v-if="initSlider" class="slider" :class="getDynamicClass(type)">

        <flickity v-if="data !== null && type !== 'home'" ref="flickity" :options="flickityOptions">

            <div v-for="(photoItem, index) in data" :key="'photo_'+ index" class="carousel-cell image" :class="'cell'+(index + 1)" :style="{backgroundImage: 'url('+ photoItem.photo.url +')'}" @click.prevent="initPhotoSwipe(index)">
                <div v-if="photoItem.photo.authorImage" class="avatar" :style="{backgroundImage: 'url('+ photoItem.photo.authorImage +')'}"></div>
                <div class="actionBtns">
                    <a :href="photoItem.photo.url" target="_blank" class="download">
                        <ion-icon name="download"></ion-icon>
                    </a>
                    <a href="#0" 
                        v-if="photoItem.photo.authorId !== null && isUserImage(photoItem.photo.authorId)" 
                        @click.prevent="deleteImage(photoItem)" 
                        class="delete">
                        <ion-icon name="trash"></ion-icon>
                    </a>
                </div>
            </div>

        </flickity>

        <flickity v-else-if="sliderData !== null" ref="flickity" :options="flickityOptions">

            <div v-for="(slide, index) in sliderData" :key="'slide_'+(index + 1)" class="carousel-cell" :class="'cell'+(index + 1)" :style="getDynamicBackground(slide)">
                <div class="slider-wrapper" :class="{dimmer: slide.dimmer, content_left: slide.has_shape}">
                    <div class="dimmer_inner">

                        <div class="slider_content">
                            <div class="slider_content_inner">
                                <template v-if="slide.title.length > 0">
                                    <h2 :style="{color: slide.text_color}">{{ slide.title[0].text }}</h2>
                                </template>
                                <template v-if="slide.description.length > 0">
                                    <p :style="{color: slide.text_color}" class="desc">{{ slide.description[0].text }}</p>
                                </template>

                                <div v-if="slide.button_router_link.length > 0">
                                    <router-link v-if="!isLoggedIn && slide.button_text[0].text === 'Sign Up'" to="register" class="btn green">Sign Up</router-link>
                                    <router-link v-if="slide.button_text[0].text !== 'Sign Up' && slide.button_text[0].text !== ''" :to="slide.button_router_link[0].text" class="btn green">{{ slide.button_text[0].text }}</router-link>
                                </div>
                                <div v-else-if="slide.button_text.length > 0">
                                    <router-link v-if="!isLoggedIn && slide.button_text[0].text === 'Sign Up'" to="register" class="btn green">Sign Up</router-link>
                                    <a v-if="slide.button_text[0].text !== 'Sign Up' && slide.button_text[0].text !== ''" :href="slide.button_link.url" class="btn green">{{ slide.button_text[0].text }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </flickity>

        <button v-if="customNextButtons" @click="previous()" class="slider-btn slider-btn-left">
            <ion-icon name="arrow-back-outline"></ion-icon>
        </button>
        <button v-if="customNextButtons" @click="next()" class="slider-btn slider-btn-right">
            <ion-icon name="arrow-forward-outline"></ion-icon>
        </button>

        <!-- Root element of PhotoSwipe. Must have class pswp. -->
        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

            <!-- Background of PhotoSwipe. 
                It's a separate element as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

            <!-- Slides wrapper with overflow:hidden. -->
            <div class="pswp__scroll-wrap">

                <!-- Container that holds slides. 
                    PhotoSwipe keeps only 3 of them in the DOM to save memory.
                    Don't modify these 3 pswp__item elements, data is added later on. -->
                <div class="pswp__container">
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>

                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
                <div class="pswp__ui pswp__ui--hidden">

                    <div class="pswp__top-bar">

                        <!--  Controls are self-explanatory. Order can be changed. -->

                        <div class="pswp__counter"></div>

                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                        <button class="pswp__button pswp__button--share" title="Share"></button>

                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                        <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                        <!-- element will get class pswp__preloader--active when preloader is running -->
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                            <div class="pswp__preloader__cut">
                                <div class="pswp__preloader__donut"></div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div> 
                    </div>

                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                    </button>

                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                    </button>

                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')
    import Flickity from 'vue-flickity'
    import * as PhotoSwipe from 'photoswipe'
    import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

    export default {
        components: {
            Flickity
        },
        props: {
            'type': String,
            'data': Array
        },
        data() {
            return {
                initSlider: false,
                photoSwipeEl: null,
                flickityOptions: {
                    wrapAround: true,
                    initialIndex: 0,
                    prevNextButtons: false,
                    pageDots: false,
                    autoPlay: 6000,
                    fullscreen: true,
                    lazyLoad: true
                },
                customNextButtons: true,
                sliderData: null
            }
        },
        beforeMount(){

            /**
             * Flickity Settings
             */

            if(this.type === 'home'){
            
                this.flickityOptions.fullscreen = false
                this.flickityOptions.lazyLoad = false
            
            }else if(this.type === 'about'){
                
                this.flickityOptions.wrapAround = false
                this.flickityOptions.contain = true

            }else if(this.type === 'event_detail'){
                this.flickityOptions.wrapAround = false 
                this.flickityOptions.contain = true
                this.flickityOptions.fullscreen = true
                this.flickityOptions.lazyLoad = true
                this.flickityOptions.autoPlay = 8000
            }

            // Mobile Version
            if(window.innerWidth < 799){
                this.customNextButtons = false
                this.flickityOptions.pageDots = true
                this.flickityOptions.freeScroll = true
                this.flickityOptions.contain = true
            }
        },
        computed: {
            isLoggedIn(){
                return this.$store.state.currentUser !== null
            }
        },
        mounted(){

            // console.log('Location: ', this.$store.state.location)

            let self = this
            
            if(this.type === 'home'){
                
                let sliderId = 'home_slider_vancouver'

                if(this.$store.state.location){
                    if(this.$store.state.location.city === 'Calgary'){
                        sliderId = 'home_slider_calgary'
                    }
                }

                this.$prismic.client.getByUID('home_slider', sliderId).then((document) => {

                    // console.log('Home Slider: ', document.data.slide)

                    self.sliderData = document.data.slide
                    self.initSlider = true
                })

            }else{
                this.initSlider = true
            }
        },
        methods: {
            next() {
                this.$refs.flickity.next();
            },
            previous() {
                this.$refs.flickity.previous();
            },
            getDynamicClass(sliderType){
                return sliderType
            },
            getDynamicBackground(slide){
                let slideStyle = ''

                if(slide.image.url){
                    slideStyle += 'background-image:url('+ slide.image.url +');'
                }
                if(slide.background_color){
                    slideStyle += 'background-color: '+ slide.background_color + ';'
                }
                if(slide.image_position === 'custom'){
                    if(slide.custom_image_position){
                        slideStyle += 'background-position: '+ slide.custom_image_position[0].text + ';'
                    }
                }

                return slideStyle
            },
            isUserImage(authorId){
                
                if(this.$store.state.currentUser === null) return
                if(this.$store.state.currentUser.uid === authorId){
                    return true
                }else{
                    return false
                }
            },
            deleteImage(photoItem){
                
                let self = this
                
                if(confirm('Are you sure you want to delete this image?')){

                    let photoRef = fb.eventsCollection.doc(photoItem.photo.eventId).collection('files').doc(photoItem.photo.id)
                    let fileRef = fb.storage.ref().child(`files/${photoItem.photo.eventId}/${photoItem.photo.fileName}`)
                    
                    photoRef.delete().then(function(){
                        fileRef.delete().then(function(){
                            console.log('Successfully deleted photo from event')
                            self.$emit('uploadSuccess')
                        }).catch(err => {
                            console.log('Error deleting photo from storage: ', err)
                        })
                    }).catch(err => {
                        console.log('Error removing photo from event! ', err)
                    })
                }
            },
            initPhotoSwipe(index){

                let pswpElement = document.querySelectorAll('.pswp')[0]
                let photoSwipeItems = []

                for(let i = 0; i < this.data.length; i++){

                    let imageUrl = this.data[i].photo.url

                    photoSwipeItems.push({
                        src: imageUrl,
                        w: 1080,
                        h: 780,
                        id: (i + 1)
                    })
                }
                
                let options = {
                    index: index ? index : 0,
                    history: false,
                    focus: false,
                    showHideOpacity: true,
                    bgOpacity: 0.9
                }

                this.photoSwipeEl = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photoSwipeItems, options)
                this.photoSwipeEl.init()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Slider.vue